//import { getField, updateField } from "vuex-map-fields";
import router from "../../router";

const state = {
    emptypushStructure: [
        {
            //"id": "", // only for editing
            "domain_id" : "",
            "title":"",
            "url":"",
            "body": "",
            "icon": "",
            "type":"recurring",
            "schedule": {
                "timezone": "",
                "time": "",
                "type": "one"
            },
            "audiences" : [],
            "segments" : [],
            "customization" : {
                "requireInteraction": false,
            },
        }  
    ],
    pushStructure: [ 
        {
            //"id": "", // only for editing
            "domain_id" : "",
            "title":"",
            "url":"",
            "body": "",
            "icon": "",
            "type":"recurring",
            "schedule": {
                "timezone": "",
                "time": "",
                "type": "one"
            },
            "audiences" : [],
            "segments" : [],
            "customization" : {
                // "button1": {
                //     "title": "",
                //     "url": ""
                // },
                // "button2": {
                //     "title": "",
                //     "url": ""
                // },
                // "image": "",
                "requireInteraction": false,
                //"ttl": ""
            },
        }
    ],
    one: [
        {
            "schedule" : {
                "domain_id": "",
                "type"       : "one",
                "name"       : "one",
                "choose_time": [
                    {  
                        "date_start" : "", 
                        "time": "", 
                        "timezone" : "" 
                    }
                ]
            },
        }
    ],
    multiple: [
        {
            "schedule" : {
                "domain_id": "",
                "type"       : "multiply",
                "name"       : "multiply",
                "choose_time": [
                    {  
                        "date_start" : "", 
                        "time": "", 
                        "timezone" : "" 
                    }
                ]
            },
        }
    ],
    recurring: [
        {
            "schedule" : {
                //"id": "", // only in editing
                "domain_id": "",
                "type"       : "recurring",
                "name"       : "recurring",
                "frequency"  : "daily",
                "time"       : "",
                "date_start" : "",
                "date_end"   : "",
                "days_of_week": [],
                "timezone"   : "",
                //"last_disp_date" : "0000-00-00 00:00:00", // only in editing
                //"next_disp_date" : "0000-00-00 00:00:00" // only in editing
            },
        }
    ]
};

// const getters = {
//     getField
// };

const actions = {
    // getSchedule({ commit }, params = "") {
    //     Segments.get(params).then((response) => {
    //         commit("ADD_AUDIENCE", response.data.data);
    //         commit("ADD_FILTERS", response.data.data[0]);
    //     });
    // },
    addMultipleSchedule({ commit }) {
        commit("ADD_MULTIPLE_SCHEDULE")
    },
    removeMultipleSchedule({ commit }, id) {
        commit("REMOVE_MULTIPLE_SCHEDULE", id)
    }
};

const mutations = {
    //updateField,
    ADD_MULTIPLE_SCHEDULE(state) {
        state.multiple[0].schedule.choose_time.push({  
            "date_start" : "", 
            "time": "", 
            "timezone" : "" 
        })
    },
    REMOVE_MULTIPLE_SCHEDULE(state, id) {
        state.multiple[0].schedule.choose_time.splice(id, 1)
    },
    // Detect Error Mutation
    DETECT_ERROR(state, error) {
        if (error.status == 401 || error.status == 419) {
        User.logout().then(() => {
            localStorage.removeItem("auth");
            //localStorage.removeItem("login");
            router.push({ name: "Login", path: router.currentRoute.path });
        }).catch((err) => {
            if (err.response) {
                commit("DETECT_ERROR", err.response);
            }
        });
        } else {
        state.error = error.data.message;
        }
    },
};

export default {
    state,
    //getters,
    actions,
    mutations
}